import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import PercentBarOpaque from "@/components/UI/PercentBarOpaque";
import {
  calculateFilledPercent,
  getParentBlockQuantity,
  parseRate,
} from "./filledPercentHelpers";

const FilledPercentCellRenderer = (params: any) => {
  const { fullTradeData, isOp } =
    returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid == fullTradeData.esid,
  );

  const blockId = params.data?.blockId;

  function determineBlock() {
    if (isOp) {
      return thisTrade?.executionRequestCounterParties?.[0]?.legs?.find(
        (block) => block.blockId == blockId,
      );
    }
    return thisTrade?.legs?.find((block) => block.blockId == blockId);
  }

  const thisBlock = determineBlock();

  const thisFill = thisBlock?.fills?.find(
    (fill) => fill.fillId == params.data.fillId,
  );

  const fillQuantity = thisFill?.fillSize ?? params.data?.fillData?.fillSize;
  const fillRate = thisFill?.fillRate ?? params.data?.fillData?.fillRate;

  let blockQuantity: number | null = null;

  if (esid && blockId !== undefined) {
    blockQuantity = getParentBlockQuantity(esid, blockId);
  }

  if (blockQuantity === null) {
    blockQuantity = params.data?.parentQuantity ?? params.data?.notionalLeg1 ?? null;
  }

  const percent = calculateFilledPercent(
    fillQuantity,
    blockQuantity ?? 0,
    parseRate(fillRate),
  );

  return <PercentBarOpaque percent={percent} testId="filledPercentCellContainer" />;
};

export default FilledPercentCellRenderer;
